import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { EXCLUSION_COUNT_CHANGES_REPORT_QUERY } from '../../../graphql.js'
import { Alert } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import '../Custom.css'
import { getData } from '../CustomUtils.js'

const EXCLUSION_COUNT_CHANGES_REPORT = gql(EXCLUSION_COUNT_CHANGES_REPORT_QUERY)

export default function ExclusionCountChangesReport({ location }) {
  console.log('ExclusionCountChangesReport rendered: ', location)

  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    getData(location, EXCLUSION_COUNT_CHANGES_REPORT, 'exclusionCountChangesReport', setResults, setGraphQLErrors)
  }, [location])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    return (
      <div className="custom-scroll">
        <div dangerouslySetInnerHTML={{ __html: results }} />
      </div>
    )
  }
}
